import { render, staticRenderFns } from "./ActiveSubstance.vue?vue&type=template&id=80fdc584"
import script from "./ActiveSubstance.vue?vue&type=script&lang=js"
export * from "./ActiveSubstance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports